<div class="flex min-w-0 flex-col gap-2 py-2">
  <div class="flex w-full items-center justify-start gap-4 px-6">
    <h2 class="textTabsColor text-2xl font-semibold" i18n="@@companiesSectionTitle">Companies</h2>
    <a
      routerLink="/user/companies"
      class="textTabsColor pt-1 text-sm font-medium hover:underline"
      i18n="@@companiesSectionViewAll">
      View All
    </a>
  </div>

  @if (error()) {
    <div class="textTabsColor px-6 text-center">{{ error() }}</div>
  } @else {
    <div class="relative flex w-full min-w-0 items-center justify-between gap-4 px-6">
      <button
        (click)="scrollLeft()"
        class="bg-primary-10 hover-bg-primary-20 z-20 flex h-12 w-12 shrink-0 cursor-pointer items-center justify-center rounded-full transition-all hover:scale-110 active:scale-95">
        <app-arrow-nav-icon variant="arrow" direction="left" />
      </button>

      <div class="relative h-[130px] flex-1 overflow-hidden">
        <div
          [@swapAnimation]="currentIndex()"
          class="absolute inset-0 grid w-full gap-4"
          [style.grid-template-columns]="'repeat(' + itemsPerView() + ', minmax(0, 1fr))'">
          @for (company of visibleCompanies(); track company.id) {
            <div
              (click)="viewCompany(company)"
              class="hover-border-primary flex h-[120px] w-full cursor-pointer items-center justify-center rounded-lg border border-transparent transition-all duration-300 hover:bg-white hover:shadow-md">
              @let imageData = companyImages.get(company.id);

              @if (imageData && imageData.isImage) {
                <img
                  [src]="imageData.url"
                  [alt]="isArabic() ? company.titleAr : company.titleEn"
                  class="h-full w-full object-contain p-2" />
              } @else {
                <span class="px-2 text-center text-sm font-semibold text-gray-700">
                  {{ isArabic() ? company.titleAr : company.titleEn }}
                </span>
              }
            </div>
          }
        </div>
      </div>

      <button
        (click)="scrollRight()"
        class="bg-primary-10 hover-bg-primary-20 z-20 flex h-12 w-12 shrink-0 cursor-pointer items-center justify-center rounded-full transition-all hover:scale-110 active:scale-95">
        <app-arrow-nav-icon variant="arrow" direction="right" />
      </button>
    </div>
  }
</div>
